import { forwardRef, ElementType, type ComponentProps } from 'react';
import { cx } from '@linaria/atomic';
import { NakedButton } from '../../naked';
import { getIconButtonClassName } from './icon-button.styles';
import { StyledBtnProps } from './types';

export const StyledIconBtn = forwardRef<HTMLButtonElement | HTMLAnchorElement, StyledBtnProps>(
  (
    {
      children,
      color = 'default',
      size,
      to,
      href,
      trackingId,
      showLabelAlways,
      label,
      labelPlacement = 'right',
      destructive,
      showLabelWhenDisabled,
      className,
      ...rest
    },
    ref
  ) => {
    const isLink = !!to || !!href;
    const Component: ElementType = !isLink ? NakedButton : 'a';
    const classes = getIconButtonClassName({ color, labelPlacement, size, showLabelAlways, destructive });
    const { disabled, onClick, ...disabledRest } = rest;
    return (
      <Component
        className={cx(classes, className)}
        //The anchor and button attributes don't line up perfectly, so we can't just spread them as one here without ts complaining
        {...(showLabelWhenDisabled ? disabledRest : (rest as ComponentProps<typeof Component>))}
        onClick={disabled ? undefined : onClick}
        ref={ref as any}
        href={disabled ? undefined : to ?? href}
        data-trackingid={trackingId}
        aria-disabled={disabled}
      >
        {children}
        {showLabelAlways && label}
      </Component>
    );
  }
);
StyledIconBtn.displayName = 'StyledIconBtn';
